import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import FilterToggles from '@/components/buttons/FilterToggles';
import { updateRoleProperties } from '../actions';
import { roleGroupings } from '../constants';

const RoleSmartPermissions = ({
  canEdit,
  category,
  code,
  grouping,
  smartFlag,
  updateFlags,
}) => {
  if (!canEdit || grouping === roleGroupings.TOKENS) {
    return null;
  }

  return (
    <FilterToggles filters={[{
      active: smartFlag,
      icon: 'magic',
      key: 'permissions_smart_flag',
      messageId: 'permissions.smart.flag',
      onClick: () => updateFlags(code, category, { smartFlag: !smartFlag }),
    }]}
    />
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { roles: { update } } } },
  roles: { roles },
}, { category, code }) => {
  const item = findResult(roles, category, code);

  return (
    {
      canEdit: item ? update && !item.system : false,
      grouping: item ? item.grouping : roleGroupings.TOKENS,
      smartFlag: item ? item.smartFlag : false,
    }
  );
};

const mapDispatchToProps = {
  updateFlags: updateRoleProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleSmartPermissions);
